import { Injectable } from '@angular/core';

import type {
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from '../note-avatar.types';

@Injectable()
export class RtNoteAvatarUpdate implements NoteAvatarUpdateStrategy {
  public getValues({
    author,
    triggered,
  }: {
    author: NoteAvatarAuthor | null;
    triggered: boolean | null;
  }): NoteAvatarInputValues {
    return {
      type: !triggered && !!author ? (author?.hasAvatar === false ? 'initials' : 'image') : 'icon',
      context: !!author ? (!!triggered ? 'candidate' : 'admin') : 'other',
      iconName: !triggered && !author ? 'person' : 'automated-actions',
      imageSrc: (!triggered && !author) || !!triggered ? null : (author?.photoThumbUrl ?? null),
      initials: author?.initials,
    };
  }
}
